import { sanitizeString } from './sanitizeString';
export var sanitizeKeyword = function (_a) {
    var keyword = _a.keyword, _b = _a.toLowerCase, toLowerCase = _b === void 0 ? true : _b;
    return sanitizeString({
        string: keyword,
        trim: true,
        removeDuplicateSpaces: true,
        alphaNumericOnly: {
            charactersToKeep: ['-', '_', '(', ')', '.', '/', '&'],
            keepSpacesBetweenWords: true,
        },
        toLowerCase: toLowerCase,
        onlyHyphenMinus: true,
    });
};
export var keywordToProperCase = function (keyword) {
    var sanitized = sanitizeKeyword({ keyword: keyword, toLowerCase: false });
    var words = sanitized.split(' ');
    return words
        .map(function (word) {
        if (word[0] === '(') {
            return word.toUpperCase();
        }
        return "".concat(word[0].toUpperCase()).concat(word.substring(1));
    })
        .join(' ');
};
//# sourceMappingURL=sanitizeKeyword.js.map